// extracted by mini-css-extract-plugin
module.exports = {"popupFeedback":"styles_popupFeedback__G_sO1","background":"styles_background__7w6WL","popupBox":"styles_popupBox__cEDHM","close":"styles_close__XuRYk"};